module.exports = {
    "": "DEPARTURE ONLY",
    "Menu mobile": "Menu mobile",
    "Logout": "Logout",
    "Choose a destination": "Choose a destination",
    "Where You're Staying": "Where You're Staying",
    "Loading": "Loading",
    "Customize your experience": "Customize your experience",
    "Home": "Home",
    "Transfers": "Transfers",
    "All Tours": "All Tours",
    "Trending & Reviews": "Trending & Reviews",
    "Specials": "Specials",
    "Wish List": "Wish List",
    "Dining": "Dining",
    "Shopping": "Shopping",
    "Contact": "Contact",
    "My Account": "My Account",
    "Tours": "Tours",
    "Get to your hotel with style, select or search your hotel to get our best selection of airport-hotel transfer services. Air conditioned comfortable coaches, minivans or private vehicles will be waiting to take you to your destination.": "Get to your hotel with style, select or search your hotel to get our best selection of airport-hotel transfer services. Air conditioned comfortable coaches, minivans or private vehicles will be waiting to take you to your destination.",
    "Select your hotel": "Select your hotel",
    "Please select your hotel from the list of available options so we can provide an accurate list of transfer options for your location.": "Please select your hotel from the list of available options so we can provide an accurate list of transfer options for your location.",
    "Select Airport Option": "Select Airport Option",
    "Arrival Airport": "Arrival Airport",
    "Departure Airport": "Departure Airport",
    "Select Below": "Select Below",
    "Note:": "Note:",
    "If the system shows arrival & departure but round trip is not available, it means that they have to be booked separately.": "If the system shows arrival & departure but round trip is not available, it means that they have to be booked separately.",
    "TRANSFERS FOUND:": "TRANSFERS FOUND:",
    " Loading...": " Loading...",
    "Loading...": "Loading...",
    "Type your Hotel Name": "Type your Hotel Name",
    "Need help?": "Need help?",
    "About": "About",
    "Privacy Policy": "Privacy Policy",
    "About us": "About us",
    "Account": "Account",
    "Terms and condition": "Terms and condition",
    "Discover": "Discover",
    "Wishlist": "Wishlist",
    "Settings": "Settings",
    "Tours Reviews": "Tours Reviews",
    "Terms & Conditions": "Terms & Conditions",
    "Special Offers": "Special Offers",
    "Empty Cart": "Empty Cart",
    "CHECKOUT": "CHECKOUT",
    "We make good vacations great": "We make good vacations great",
    "PLACE YOUR ORDER": "PLACE YOUR ORDER",
    "Search Tours": "Search Tours",
    "Search terms": "Search terms",
    "Type your search terms": "Type your search terms",
    "Destination": "Destination",
    "Search Transfers": "Search Transfers",
    "Select": "Select",
    "Search now": "Search now",
    "Hotel Name": "Hotel Name",
    "CHANGE": "CHANGE",
    "Seleccione": "Seleccione",
    "NOT CERTAIN": "NOT CERTAIN",
    "ALL AREAS": "ALL AREAS",
    "No Hotels found": "No Hotels found",
    "Select Arrival Airport": "Select Arrival Airport",
    "Rates are per": "Rates are per",
    "in": "in",
    "DESCRIPTION": "DESCRIPTION",
    "ARRIVAL ONLY": "ARRIVAL ONLY",
    "(NOT AVAILABLE)": "(NOT AVAILABLE)",
    "ROUND TRIP": "ROUND TRIP",
    "DEPARTURE ONLY": "DEPARTURE ONLY",
    "NOT AVAILABLE": "NOT AVAILABLE",
    "WELCOME": "WELCOME",
    "TO": "TO",
    "<span class='orange_t'>TOUR</span><span class='blue_t'> REVIEWS</span>": "<span class='orange_t'>TOUR</span><span class='blue_t'> REVIEWS</span>",
    "See What's Hot And What Other vacations have to say": "See What's Hot And What Other vacations have to say",
    "See Tours": "See Tours",
    "Read Reviews": "Read Reviews",
    "\"...the Royal Swim was perfect for us ...<br />we wanted a great experience and we got it... \"": "\"...the Royal Swim was perfect for us ...<br />we wanted a great experience and we got it... \"",
    "BUY 2 Tours AND GET a 3<sup>rd</sup> ONE FREE": "BUY 2 Tours AND GET a 3<sup>rd</sup> ONE FREE",
    "<span class='orange_t'>GET</span><span class='yellow_t'> THE</span><span class='blue_t'> APP</span>": "<span class='orange_t'>GET</span><span class='yellow_t'> THE</span><span class='blue_t'> APP</span>",
    "<span class='orange_t'>FREE</span><span class='blue_t'> TOUR</span>": "<span class='orange_t'>FREE</span><span class='blue_t'> TOUR</span>",
    "See How!": "See How!",
    "Vacation Offers & Features": "Vacation Offers & Features",
    "Download Now!": "Download Now!",
    "\"FREE CALLS to the concierge before & during vacation<br />Transfers, Tours, and more!\"": "\"FREE CALLS to the concierge before & during vacation<br />Transfers, Tours, and more!\"",
    "AIRPORT TRANSFERS ~ GET TO YOUR HOTEL IN STYLE!": "AIRPORT TRANSFERS ~ GET TO YOUR HOTEL IN STYLE!",
    "Our <span class='blue_text'>Destinations</span>": "Our <span class='blue_text'>Destinations</span>",
    "Discover our Top tours <span>now</span>": "Discover our Top tours <span>now</span>",
    "Know our places and be happy": "Know our places and be happy",
    "See our best tour places at Totoura": "See our best tour places at Totoura",
    "Read more": "Read more",
    "Some <span class='blue_text'>good</span> reasons": "Some <span class='blue_text'>good</span> reasons",
    "VACATIONER REVIEWS": "VACATIONER REVIEWS",
    "We have the best reasons to travel": "We have the best reasons to travel",
    "Products & Prices Guaranteed!": "Products & Prices Guaranteed!",
    "FROM": "FROM",
    "From": "From",
    "Details": "Details",
    "Review": "Review",
    "Add Cart": "Add Cart",
    "Add to wishlist": "Add to wishlist",
    "Top Rated": "Top Rated",
    "Delete from wishlist": "Delete from wishlist",
    "Searching": "Searching",
    "Click on tours you like to build a Wish List": "Click on tours you like to build a Wish List",
    "Tour & ACTIVITES in": "Tour & ACTIVITES in",
    "We will look for specials and enter you to win your favorites": "We will look for specials and enter you to win your favorites",
    "Find your Perfect Tour:": "Find your Perfect Tour:",
    "By Category": "By Category",
    "3rd Tour Free": "3rd Tour Free",
    "Land": "Land",
    "Type your search keyword here & press enter key...": "Type your search keyword here & press enter key...",
    "Water": "Water",
    "Cultural": "Cultural",
    "Nightlife": "Nightlife",
    "Adventure": "Adventure",
    "Family": "Family",
    "Select All": "Select All",
    "Unselect All": "Unselect All",
    "founds": "founds",
    "Valid 3rd Tour Free": "Valid 3rd Tour Free",
    "Searching...": "Searching...",
    "Detail": "Detail",
    "No results found...": "No results found...",
    "Name": "Name",
    "Be in Touch": "Be in Touch",
    "Enter Name": "Enter Name",
    "Contact Us!": "Contact Us!",
    "\"Enter Email\"": "\"Enter Email\"",
    "Email": "Email",
    "Message": "Message",
    "Write your message": "Write your message",
    "USA / CANADA": "USA / CANADA",
    "Submit": "Submit",
    "CANCUN / COZUMEL PUERTO VALLARTA / LOS CABOS": "CANCUN / COZUMEL PUERTO VALLARTA / LOS CABOS",
    "Toll Free": "Toll Free",
    "DOMINICAN REPUBLIC": "DOMINICAN REPUBLIC",
    "PUNTA CANA": "PUNTA CANA",
    "For inquiries please email us at": "For inquiries please email us at",
    "or simply fill out the online contact form": "or simply fill out the online contact form",
    "PUERTO PLATA": "PUERTO PLATA",
    "Enter your name": "Enter your name",
    "Enter a valid email": "Enter a valid email",
    "Enter your Message - More than 20 characters": "Enter your Message - More than 20 characters",
    "Arrival": "Arrival",
    "Departure": "Departure",
    "Round": "Round",
    "translate test": "translate test",
    "By agreeing to the Conditions of Use of Totoura?s websites and/or mobile applications Customer agrees to the collection, use and disclosure of its personal information as outlined above.   To the extent provided by applicable law, Customer may request access and correction of its personal information held by TOTOURA by contacting it at the email address set out above.": "By agreeing to the Conditions of Use of Totoura?s websites and/or mobile applications Customer agrees to the collection, use and disclosure of its personal information as outlined above.   To the extent provided by applicable law, Customer may request access and correction of its personal information held by TOTOURA by contacting it at the email address set out above.",
    "Every individual or legal entity (hereafter referred to as the ?Customer?) by the mere fact of accessing, visiting or registering himself/herself in the Web Site, is automatically subject to the present terms and conditions, as well as to its future modifications. The Customer hereby declares and warrants that he/she is over 18 years of age and has the legal capacity and attributions necessary to purchase or hire in his/her own capacity or in behalf of the legal entity that the Customer declares to represent, as well as to order the charges to the credit card which information he/she provides. The parents and tutors are responsible for the purchases or reservations on-line that are made by the children under their responsibility, with or without their prior approval.": "Every individual or legal entity (hereafter referred to as the ?Customer?) by the mere fact of accessing, visiting or registering himself/herself in the Web Site, is automatically subject to the present terms and conditions, as well as to its future modifications. The Customer hereby declares and warrants that he/she is over 18 years of age and has the legal capacity and attributions necessary to purchase or hire in his/her own capacity or in behalf of the legal entity that the Customer declares to represent, as well as to order the charges to the credit card which information he/she provides. The parents and tutors are responsible for the purchases or reservations on-line that are made by the children under their responsibility, with or without their prior approval."
}